import axios from "../axios";
import _get from "lodash/get";
import * as cookie from "react-cookie";
import * as TYPES from "./authActionTypes";
import { cookieOptions, getAuthUrl } from "../../constants";
import * as rdd from "react-device-detect";

const cookies = new cookie.Cookies();

function setCookie(key, value) {
  cookies.set(key, value, cookieOptions);
}

function removeCookie(key) {
  cookies.remove(key, cookieOptions);
}

export const setProfile = (value) => ({
  type: TYPES.PROFILE,
  value,
});

export const setBusiness = (value) => ({
  type: TYPES.BUSINESS,
  value,
});

export const setAuthToken = (value) => ({
  type: TYPES.AUTH_TOKEN,
  value,
});

export const setTrackerToken = (value) => ({
  type: TYPES.TRACKER_TOKEN,
  value,
});

export const authBusy = value => ({
  type: TYPES.AUTH_BUSY,
  value
});

export const preCheck = (value) => ({
  type: TYPES.PRE_CHECK,
  value,
});

export function signIn({ email, password, isToken, token }) {
  return async (dispatch, getState) => {
    dispatch(authBusy(true));
    const latitude = _get(getState(), "appData.coords.latitude", "0");
    const longitude = _get(getState(), "appData.coords.longitude", "0");
    const ip = _get(getState(), "appData.ip", "");
    const date = new Date();

    let params = {
      ip,
      email,
      password,
      os: rdd.osName,
      browser: rdd.browserName,
      timestamp: date.getTime(),
      latitude,
      longitude
    };

    if (isToken) {
      params.token = token;
    }

    try {
      const response = await axios({
        // url: `${BASE_URL}/members/login?include=user`,
        url: `/members/login?include=user`,
        timeout: 20000,
        method: "post",
        data: params
      });

      const _response = response.data || {};
      const token = _response.id;
      const jwtToken = _get(_response, "user.jwtToken");

      setCookie("token", token);
      setCookie("jwtToken", jwtToken);
      setCookie("businessId", _response.businessId);
      setCookie("userId", _response.userId);

      dispatch(setProfile(_response.user));
      dispatch(setBusiness(_response.business));
      dispatch(setAuthToken(token));
      dispatch(authBusy(false));

      return _response;
    } catch (error) {
      dispatch(authBusy(false));
      const statusCode = _get(error, "response.status");
      const statusText = _get(error, "response.statusText");
      const message =
        _get(error, "response.data.errors[0].message") ||
        `${statusCode} ${statusText}`;
      return message;
    }
  };
}

export function signOut() {
  return async (dispatch, getState) => {
    try {
      const response = await axios({
        url: `/members/logout`,
        timeout: 20000,
        method: "post",
        data: {},
      });

      const _response = response.data;

      removeCookie("token");
      removeCookie("jwtToken");
      removeCookie("businessId");
      removeCookie("userId");

      dispatch(setProfile(null));
      dispatch(setBusiness(null));
      dispatch(setAuthToken(null));

      // window.location.href = getAuthUrl();
      return _response;
    } catch (error) {
      const statusCode = _get(error, "response.status");
      const statusText = _get(error, "response.statusText");
      const message =
        _get(error, "response.data.errors[0].message") ||
        `${statusCode} ${statusText}`;
      return message;
    }
  };
}

export function getProfile(params = {}) {
  return async (dispatch, getState) => {
    const token = cookies.get("token", {
      path: "/",
    });

    if (!token) {
      // window.location.href = getAuthUrl();
      console.log('getAuthUrl ========= ');
      dispatch(preCheck(false));
      const _location = window.location;
      if (!_location.pathname.includes("/login")) {
        window.location.href = getAuthUrl();
      }
      return;
    }

    try {
      const resTraccars = await axios({
        url: `/osritTokens/gps`,
        method: "get",
        headers: {
          authorization: token,
        },
      });

      const trackerData = _get(resTraccars, "data", {});
      dispatch(setTrackerToken(trackerData));
    } catch (e) {
      console.log(e);
    }

    try {
      const response = await axios({
        url: `/osritTokens/${token}`,
        method: "get",
        params,
      });
      const _response = response.data;

      dispatch(setProfile(_response.member));
      dispatch(setBusiness(_response.business));
      dispatch(setAuthToken(token));
      dispatch(preCheck(true));

      return _response;
    } catch (e) {
      const _location = window.location;

      if (!_location.pathname.includes("/login")) {
        // window.location.href = getAuthUrl();
      }
    }
  };
}
